import styled from '@emotion/styled';
import { screenSizes } from '../Literals';

export const DatesComponent = styled('div')`
  width: 80%;
  margin: 50px auto;
  .Registration__form {
    padding: 20px;
  }
  .date {
    width: 20%;
    display: inline-block;
    margin: 10px 0;
  }
  .save {
    background-color: white;
    position: sticky;
    width: 100%;
    bottom: 0;
    right: 125px;
  }
  @media only screen and (max-width: ${screenSizes.tablet}) {
    width: 95%;
    .date {
      width: 33.33%;
    }
  }
  @media only screen and (max-width: 600px) {
    .date {
      width: 50%;
    }
  }
`;
